import {Injectable} from "@angular/core";
import {rxResource} from "@angular/core/rxjs-interop";
import {sendCommandAndWait, sendQuery} from "../../common/utils";
import {EmergencyProcedure} from "@portbase/bezoekschip-service-typescriptmodels";
import {from, Observable, of, toArray} from "rxjs";
import {catchError, concatMap, map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class EmergencyProcedureService {

  readonly emergencyProceduresResource = rxResource({
    defaultValue: [] as EmergencyProcedure[],
    stream: () => sendQuery<EmergencyProcedure[]>(
      'com.portbase.bezoekschip.common.api.emergencyprocedure.GetEmergencyProcedures',
      {},
      { caching: false }
    )
  });

  static isEmergencyProcedureDisabled(): boolean {
    return document.location.hostname === 'portvisit.pcs.portbase.com';
  }

  isEmergencyProcedureEnabledForPort(portUnCode: string): boolean {
    return this.emergencyProceduresResource.value().some(ep => ep.portUnCode === portUnCode && ep.enabled);
  }

  saveEmergencyProcedureSettings(editableEmergencyProcedureSettings: EmergencyProcedure[]): Observable<boolean> {
    return from(editableEmergencyProcedureSettings).pipe(
        concatMap(setting => {
          const emergencyProcedureSetting = <EmergencyProcedure>{
            portUnCode: setting.portUnCode,
            enabled: setting.enabled
          };
          return sendCommandAndWait(
              'com.portbase.bezoekschip.common.api.emergencyprocedure.UpdateEmergencyProcedure',
              emergencyProcedureSetting
          );
        }),
        toArray(),
        map(() => true),
        catchError(() => of(false))
    );
  }
}
